import angular from 'angular';
import template from './template.html';
import './style.scss';

export const TYPE_CLASSES = {
    error: 'error',
    info: 'info',
};

export class TFTLabel {
    innerValue = '';

    $onChanges() {
        this.labelClass = this.getLabelClass(this.type);
    }

    getLabelClass(type) {
        return TYPE_CLASSES[type] || '';
    }
}

export const TFTLabelConfig = {
    template,
    bindings: {
        valueKey: '<',
        type: '@',
        testId: '@',
    },
    controller: TFTLabel,
    controllerAs: 'tftLabelCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftLabel', TFTLabelConfig);
